export const login = {
    contentLogin: 'APP AIS 계정으로 로그인할 수 있습니다.',
    downloadApp: '앱 AIS 다운로드',
    downloadInstructions: '다운로드 지침',
    buttonLogin: '로그인',
    passwordLabel: '비밀번호',
    title: '로그인',
    forGetPassword: '비밀번호를 잊으 셨나요?',
    register: '등록하기',
    noAccount: '계정이 없습니까?',
};
